import { ArrowUpIcon } from "lucide-react";
import { Loader2Icon } from "lucide-react";
import { SquareIcon } from "lucide-react";
import { XIcon } from "lucide-react";
import { InputGroupButton } from "@src/components/ui/input-group";
import { cn } from "@src/lib/utils";
import type { PromptInputSubmitProps } from "./PromptInputSubmitProps";

export const PromptInputSubmit = ({
  className,
  variant = "default",
  size = "icon-sm",
  status,
  onStop,
  disabled,
  onClick,
  children,
  ...props
}: PromptInputSubmitProps) => {
  let Icon = <ArrowUpIcon color="white" className="size-4" />;
  if (status === "submitted") {
    Icon = <Loader2Icon className="size-4 animate-spin" />;
  } else if (status === "streaming") {
    Icon = <SquareIcon color="white" fill="white" className="size-4" />;
  } else if (status === "error") {
    Icon = <XIcon className="size-4" />;
  }

  const isStopMode = status === "streaming" && !!onStop;

  // `onStop` is typed `() => void`, so the button must call it with no
  // arguments rather than hand it straight to `onClick`. Callers forward their
  // first argument into a request body (`useStopChat` ->
  // `/workflows/execution/:id/cancel`), and a React synthetic event is a
  // circular structure, so serializing it throws and the cancel never fires.
  const handleClick = isStopMode ? () => onStop?.() : onClick;

  return (
    <InputGroupButton
      aria-label={isStopMode ? "Stop" : "Submit"}
      className={cn(
        // Caller last: `cn` is tailwind-merge, so whichever background class
        // comes last wins. With `className` first these defaults silently beat
        // anything a caller passed, making the button unstyleable from outside.
        "bg-foreground",
        "hover:bg-foreground/60",
        className
        // "group-has-[[data-slot=input-group-control]:focus-visible]/input-group:bg-foreground",
        // "group-has-[[data-slot=input-group-control]:focus-visible]/input-group:hover:bg-foreground/60"
      )}
      size={size}
      type={isStopMode ? "button" : "submit"}
      variant={variant}
      disabled={isStopMode ? false : disabled}
      onClick={handleClick}
      {...props}
    >
      {children ?? Icon}
    </InputGroupButton>
  );
};
